// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useNavigate } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { MouseEvent } from "react";
import type { AnswerLink as AnswerLinkData } from "@/features/assistant/types";

/** A real anchor (middle-click and copy-link work) that navigates client-side on a plain click. */
/** `onNavigate` runs after a client-side navigation (the full-screen mobile panel closes itself). */
export function AnswerLink({ link, onNavigate }: { link: AnswerLinkData; onNavigate?: () => void }) {
  const navigate = useNavigate();
  function onClick(e: MouseEvent<HTMLAnchorElement>) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    void navigate({ href: link.href });
    onNavigate?.();
  }
  return (
    <a
      href={link.href}
      onClick={onClick}
      className="mb-2 flex items-center justify-between rounded-lg border px-3 py-2 font-medium text-sm hover:border-primary hover:bg-primary/5"
    >
      {link.label}
      <ArrowRight className="size-4 text-primary" />
    </a>
  );
}
